
import { Grid, GridCellProps, GridColumn, GridCustomCellProps } from '@progress/kendo-react-grid';
import { getHoldNotes } from '../services/apiService';
import { SubmissionContext } from './SubmissionFormContext';
import { PageContext } from './PageContext';
import { useContext, useEffect, useState } from 'react';
import { makeLongDate } from './DateTimeHelpers';

interface holdNote{
    time:number
    user_name:string
    operation:string
}

const HoldNotesList=()=>{
const subContext = useContext(SubmissionContext);
const pageContext=useContext(PageContext);
    const [holdNotes, setHoldNotes] = useState<holdNote[]>();


    const formatCell=(e:GridCellProps)=>{
        const time = e.dataItem.time.toString();
        const locale = pageContext?.glSettings.Locale||"en-US"
        const formatTime = makeLongDate(time, locale);        
        return (
            <td>
                {formatTime}
            </td>
        );
    }

    useEffect(()=>{
        if (subContext){
            getHoldNotes(subContext.submitForm.element).then(data=>{
                setHoldNotes(data);
            });
        }

    })
    return(
        <Grid
            className='mt-3' 
            data={holdNotes}                    
        >
            <GridColumn
                field='time'
                title='Date'
                width={"100px"}
                cells={{data:formatCell}}
            />
            <GridColumn title='Operation' field='operation'/>
        </Grid>
    )

}

export const SubmitHold=(
    <>
    <h5>HOLD NOTES</h5>
    <HoldNotesList></HoldNotesList>
    </>
)